/** @format */

import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { CHROME_HIDE_SELECTOR_CONST } from "../../../core/libs";
import { ModalDialogService } from "../../../shared/common/commondialog/dialog.service";

@Injectable({
   providedIn: "root"
})
export class ChromeHideSelectorService {
   private selectorWindow: chrome.app.AppWindow = null;
   private isHidden = false;
   private modalSubscription: Subscription;

   constructor(private modalDialogService: ModalDialogService) {}

   // check the Admin Policy and the user setting to determine whether to hide the selector page
   // this should only be called on the selector page
   public checkSettingsAndHideSelectorWindow(adminCommonSettings: any) {
      // if is Kiosk mode, do nothing
      if (window.isKioskSession) {
         return;
      }
      // first check admin policy
      let adminHideSetting = undefined;
      if (adminCommonSettings) {
         adminHideSetting = adminCommonSettings[CHROME_HIDE_SELECTOR_CONST.HIDE_SELECTOR_ADMIN_POLICY_KEY];
      }
      if (adminHideSetting === undefined) {
         // then check local setting
         chrome.storage.local.get(CHROME_HIDE_SELECTOR_CONST.HIDE_SELECTOR_SETTING_STORAGE_KEY, (value) => {
            if (value[CHROME_HIDE_SELECTOR_CONST.HIDE_SELECTOR_SETTING_STORAGE_KEY]) {
               this.hideCurrentWindowAndAddContextMenu();
            }
         });
      } else if (adminHideSetting) {
         this.hideCurrentWindowAndAddContextMenu();
      }
   }

   public showSelectorIfIsHidden() {
      if (!this.selectorWindow || window.isKioskSession) {
         return;
      }
      this.selectorWindow.show();
      this.selectorWindow.focus();
      this.isHidden = false;
      chrome.contextMenus.remove(CHROME_HIDE_SELECTOR_CONST.OPEN_SELECTOR_MENU_ID);
   }

   public quitClientIfSelectorIsHidden() {
      if (this.selectorWindow && this.isHidden && !window.isKioskSession) {
         this.selectorWindow.close();
      }
   }

   // hide the selector page and add a context menu item to show the selector
   private hideCurrentWindowAndAddContextMenu() {
      this.selectorWindow = chrome.app.window.current();
      this.selectorWindow.hide();
      this.isHidden = true;
      // add an item to show the window in the context menu
      chrome.contextMenus.create({
         title: chrome.i18n.getMessage("OPEN_SELECTOR_PAGE_T"),
         id: CHROME_HIDE_SELECTOR_CONST.OPEN_SELECTOR_MENU_ID,
         contexts: ["launcher"]
      });
      // subscribe to modalDialogService
      // show the selector page whenever there's a modal opened in the main window
      if (!this.modalSubscription) {
         this.modalSubscription = this.modalDialogService.subscribe(() => {
            // use setTimeout for the edge case:
            // in hidden state, disconnect the only opened desktop using Windows' menu
            // this will cause a popup but we want to quit the client instead of showing the selector
            setTimeout(() => {
               this.showSelectorIfIsHidden();
            }, 100);
         });
         // add listener for context menu item click
         chrome.contextMenus.onClicked.addListener((itemData) => {
            if (itemData.menuItemId === CHROME_HIDE_SELECTOR_CONST.OPEN_SELECTOR_MENU_ID) {
               this.showSelectorIfIsHidden();
            }
         });
      }
   }
}
